import { render, staticRenderFns } from "./cate09.vue?vue&type=template&id=6472fbec"
import script from "./cate09.vue?vue&type=script&lang=js"
export * from "./cate09.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports